export interface BalanceState {
  isLoading: {
    list: boolean;
    createBalance: boolean;
    createOperation: boolean;
  };
  errors: {
    list: string | null;
    createBalance: string | null;
    createOperation: string | null;
  };
  balance: BalanceDTO | null;
}

// DTO для баланса
export interface BalanceDTO {
  number: number;
  pk: string;
  is_active: boolean;
  operations: OperationDTO[];
  total: string;
}

// DTO для операции
export interface OperationDTO {
  direction: number; // направление операции, возможно, 0 - доход, 1 - расход
  amount: string; // сумма операции
  pk: string; // уникальный идентификатор операции
  is_active: boolean; // статус активности операции
}

// Получение баланса
export const GET_BALANCE_REQUEST = 'GET_BALANCE_REQUEST';
export const GET_BALANCE_SUCCESS = 'GET_BALANCE_SUCCESS';
export const GET_BALANCE_FAILURE = 'GET_BALANCE_FAILURE';

// Создание баланса
export const CREATE_BALANCE_REQUEST = 'CREATE_BALANCE_REQUEST';
export const CREATE_BALANCE_SUCCESS = 'CREATE_BALANCE_SUCCESS';
export const CREATE_BALANCE_FAILURE = 'CREATE_BALANCE_FAILURE';

// Создание операции
export const CREATE_OPERATION_REQUEST = 'CREATE_OPERATION_REQUEST';
export const CREATE_OPERATION_SUCCESS = 'CREATE_OPERATION_SUCCESS';
export const CREATE_OPERATION_FAILURE = 'CREATE_OPERATION_FAILURE';
